import { get, map } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  trackArticleCarouselArrow,
  trackRelatedProject,
} from '../../../common/analytics/analyticsTracker';
import { PP } from '../../../common/analytics/sourceTypes';
import { WholeState } from '../../../store/common/type';
import { WholeState as SearchState } from '../../../store/search/type';
import SimpleCarousel from '../../simpleCarousel/SimpleCarousel';
import SimpleProjectCard, {
  ProjectCardClickEvent,
} from '../../simpleProjectCard/SimpleProjectCard';
import projectResource from '../../../locales/th/project.json';
import {
  OtherNearbyProjectTitle,
  ProjectListCarouselWrapper,
  Wrapper,
  TopContentWrapper,
} from './OtherNearbyProject.style';
import { AnalyticsProject } from '../../../common/analytics/interfaces/analyticsProject';
import { ProjectNearbyQueryResponse } from '../../../queries/projectPage/projectNearby';

export const PER_PAGE = 20;
const DESKTOP_SLIDES_TO_SCROLL = 3;
const TABLET_SLIDES_TO_SCROLL = 2;
const MOBILE_SLIDES_TO_SCROLL = 1;

interface OtherNearbyProjectProps {
  nearbyProjectData: ProjectNearbyQueryResponse;
}

const OtherNearbyProject: React.FC<OtherNearbyProjectProps> = ({
  nearbyProjectData,
}) => {
  const loading = useSelector<SearchState, boolean>((state) =>
    state.search ? state.search.loadingProjectsCarousel : false,
  );

  const userInfo = useSelector((state: WholeState) =>
    state !== undefined ? state.common.user : {},
  );

  const changeSlides = (to: number) => {
    if (to === 0) {
      return;
    }

    trackArticleCarouselArrow(userInfo, PP.PAGE);
  };

  const handleClickProjectCard = (event: ProjectCardClickEvent) => {
    const projectInfo: AnalyticsProject = {
      id: event.id,
      propertyType: event.propertyTypes,
      developer: event.developerName,
      title: event.title,
      location: event.location,
      priceTypes: event.priceTypes,
      transportations: event.transportations,
    };
    trackRelatedProject(userInfo, projectInfo, PP.PAGE);
  };

  const data = nearbyProjectData?.otherNearbyProjectData?.items;
  const otherNearbyProjectTitle = projectResource.otherNearbyProject.title;

  const renderOtherNearbyProjectContent = () => {
    return map(data, (item) => {
      const {
        id,
        title,
        link,
        featuredImage,
        propertyType,
        priceTypes,
        location,
        developer,
        logo,
        transportations,
      } = item;

      return (
        <SimpleProjectCard
          key={id}
          id={id}
          title={title}
          link={link}
          featuredImageUrl={get(featuredImage, 'url', '')}
          location={location}
          propertyTypes={propertyType}
          priceTypes={priceTypes}
          transportations={transportations}
          developerName={get(developer, 'name', '')}
          logoUrl={get(logo, 'image.url', '')}
          logoBgColor={get(logo, 'background_color', '')}
          onClickProjectCard={handleClickProjectCard}
        />
      );
    });
  };

  return (
    <TopContentWrapper>
      <Wrapper>
        <ProjectListCarouselWrapper data-test={'project-list-carousel'}>
          {loading && data?.length !== 0 && (
            <>
              <OtherNearbyProjectTitle>
                {otherNearbyProjectTitle}
              </OtherNearbyProjectTitle>
              <SimpleCarousel
                data-test="simple-carousel"
                onChangeSlides={changeSlides}
                slidesToScrollConfig={{
                  desktop: DESKTOP_SLIDES_TO_SCROLL,
                  smallDesktop: TABLET_SLIDES_TO_SCROLL,
                  tablet: TABLET_SLIDES_TO_SCROLL,
                  small: MOBILE_SLIDES_TO_SCROLL,
                }}
              >
                {renderOtherNearbyProjectContent()}
              </SimpleCarousel>
            </>
          )}
        </ProjectListCarouselWrapper>
      </Wrapper>
    </TopContentWrapper>
  );
};

export default OtherNearbyProject;
